// extracted by css-extract-rspack-plugin
export default {"icon":"SidebarLinkIcon-module__icon__wnHFw"};